import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import { sagaFunctions } from "../../utils";
import {
  Categories,
  AddCategories,
  DeleteCategories,
  CategoriesStatus,
  AccountTxns,
} from "./categories";
import { Skeleton } from "antd";

function getCategories(req) {
  return sagaFunctions(Categories, "get", apis.categories, req.payload, {
    headers: {
      Authorization: sessionStorage.getItem("token"),
    },
    SkipSuccessMessage: true,
  })();
}

function accountTxns(req) {
  return sagaFunctions(AccountTxns, "get", apis.accountTxns, req.payload, {
    headers: {
      Authorization: sessionStorage.getItem("token"),
    },
    skipSuccessMessage: true,
  })();
}

function updateCategoriesStatus(req) {
  return sagaFunctions(
    CategoriesStatus,
    "post",
    apis.categoriesStatus,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
      Authorization: sessionStorage.getItem("token"),
    },
  )();
}

function addCategories(req) {
  return sagaFunctions(AddCategories, "post", apis.categories, req.payload, {
    "Content-Type": "multipart/formdata",
    Authorization: sessionStorage.getItem("token"),
  })();
}

function deleteCategories(req) {
  return sagaFunctions(
    DeleteCategories,
    "post",
    apis.deleteCategories,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
      Authorization: sessionStorage.getItem("token"),
    },
  )();
}

export function* categoriesWatcher() {
  yield takeLatest(Categories.REQUEST, getCategories);
  yield takeLatest(CategoriesStatus.REQUEST, updateCategoriesStatus);
  yield takeLatest(AddCategories.REQUEST, addCategories);
  yield takeLatest(DeleteCategories.REQUEST, deleteCategories);
  yield takeLatest(AccountTxns.REQUEST, accountTxns);
}
